import PrizeDetailPage from './PrizeDetailPage';

export default PrizeDetailPage;